import { BodyMapView } from './body-map.types';

export type BodyMapModel = 'male' | 'female';
export type StoredBodyMapView = 'front' | 'back';

export interface BodyMapMarkerSource {
  bodyMapModel?: string | null;
  bodyMapView?: string | null;
  bodyMapX?: number | null;
  bodyMapY?: number | null;
  bodyMapZ?: number | null;
}

export interface BodyMapMarker {
  model: BodyMapModel;
  view: StoredBodyMapView;
  x: number;
  y: number;
  z: number;
}

export function parseBodyMapMarker(
  source: BodyMapMarkerSource,
): BodyMapMarker | null {
  const model = source.bodyMapModel?.trim().toLowerCase();
  const view = source.bodyMapView?.trim().toLowerCase();
  const { bodyMapX: x, bodyMapY: y, bodyMapZ: z } = source;

  if (
    (model !== 'male' && model !== 'female') ||
    (view !== 'front' && view !== 'back') ||
    !isFiniteNumber(x) ||
    !isFiniteNumber(y) ||
    !isFiniteNumber(z)
  ) {
    return null;
  }

  return { model, view, x, y, z };
}

export function bodyMapModelAsset(marker: BodyMapMarker): string {
  return marker.model === 'female'
    ? 'assets/body-map-3d/female_base_rev1.glb'
    : 'assets/body-map-3d/human1.gltf';
}

export function bodyMapInitialView(marker: BodyMapMarker): BodyMapView {
  return marker.view === 'back' ? 'BACK' : 'FRONT';
}

function isFiniteNumber(value: unknown): value is number {
  return typeof value === 'number' && Number.isFinite(value);
}
